import { Component, OnInit, OnDestroy, ViewEncapsulation } from '@angular/core';
import { CriticalEditionService } from '../../../services/critical-edition.service';
import { CeStructureTree } from '../../../models/ce-structure-tree';
import { ISubscription } from 'rxjs/Subscription';

@Component({
  selector: 'app-page-critical-edition-samples',
  templateUrl: './page-critical-edition-samples.component.html',
  styleUrls: ['./page-critical-edition-samples.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class PageCriticalEditionSamplesComponent implements OnInit, OnDestroy {
    pageName = 'critical_edition_samples';
    private subscriptions: Array<ISubscription> = [];
    ceStructureTree: CeStructureTree;

    constructor(
        private criticalEditionService: CriticalEditionService
    ) {
    }

    ngOnInit(): void {
        /* Sample structure list */
        this.subscriptions.push(
            this.criticalEditionService.getStructureTree(true).subscribe(
                response => this.ceStructureTree = response,
                err => console.error(err)
            )
        );
    }

    ngOnDestroy() {
        for (const subscription of this.subscriptions) {
            if (subscription) {
                subscription.unsubscribe();
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/components/pages/page-critical-edition-samples/page-critical-edition-samples.component.ts